import { render, staticRenderFns } from "./multiInputData.vue?vue&type=template&id=29e21843&"
import script from "./multiInputData.vue?vue&type=script&lang=js&"
export * from "./multiInputData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports